export const KYC = '/fa/kyc';
export const P2P_STATIC = '/fa/trade';
export const P2P = '/fa/trade/:market';
export const P2P_MARKET_DETAIL = '/fa/trade/:market/detail';
export const CHART = '/fa/trade/chart/:source/:market';
// export const OTC = '/fa/convert';
export const WALLET = '/fa/my/wallet/account/main';
/** Views of the wallet page that live in its query string. */
export const WALLET_VIEW_PARAM = 'view';
export const SMALL_ASSETS_VIEW = 'small-assets';
export const WALLET_SMALL_ASSETS = `${WALLET}?${WALLET_VIEW_PARAM}=${SMALL_ASSETS_VIEW}`;
export const FIAT_DEPOSIT =
  '/fa/my/wallet/account/main/deposit/fiat/TMN/:tabType';
// Helper function to generate fiat deposit URLs
export const getFiatDepositUrl = (
  tabType?: 'ipg' | 'iban' | 'card-transfer' | 'account-transfer'
) => {
  if (!tabType || tabType === 'ipg') {
    return '/fa/my/wallet/account/main/deposit/fiat/TMN/card-transfer';
  }
  return `/fa/my/wallet/account/main/deposit/fiat/TMN/${tabType}`;
};
export const FIAT_WITHDRAW = '/fa/my/wallet/account/main/withdraw/fiat/TMN';
export const CRYPTO_DEPOSIT =
  '/fa/my/wallet/account/main/deposit/crypto/:symbol';
// Helper function to generate crypto deposit URLs

export const CRYPTO_DEPOSIT_RAW = '/fa/my/wallet/account/main/deposit/crypto/';
export const getCryptoDepositUrl = (symbol?: string) => {
  if (!symbol) {
    return '/fa/my/wallet/account/main/deposit/crypto/';
  }
  return `/fa/my/wallet/account/main/deposit/crypto/${symbol.toUpperCase()}`;
};
export const CRYPTO_WITHDRAW =
  '/fa/my/wallet/account/main/withdraw/crypto/:symbol';
export const CRYPTO_WITHDRAW_RAW =
  '/fa/my/wallet/account/main/withdraw/crypto/';

export const getCryptoWithdrawUrl = (symbol?: string) => {
  if (!symbol) {
    return '/fa/my/wallet/account/main/withdraw/crypto/';
  }
  return `/fa/my/wallet/account/main/withdraw/crypto/${symbol.toUpperCase()}`;
};

export const DASHBOARD = '/fa/';
export const WALLET_HISTORY = '/fa/my/wallet/history/';
export const OTC_HISTORY = '/fa/my/wallet/history/otc';
export const P2P_HISTORY = '/fa/my/wallet/history/p2p';
export const SMALL_BALANCE_HISTORY = '/fa/my/wallet/history/small-balance';
export const PROFILE = '/fa/my/profile';
export const PROFILE_LINKS = '/fa/my/profile/links';
export const TIERS = '/fa/my/profile/tiers';
export const SECURITY = '/fa/my/profile/security';
export const ACTIVITIES = '/fa/my/profile/security/activities';
export const ACTIVESESSIONS = '/fa/my/profile/security/sessions';
export const NEW_TICKET = '/fa/my/ticket/new';
export const SHOW_TICKET = '/fa/my/ticket/:id';
export const TICKET = '/fa/my/ticket';
export const PORTFOLIO = '/fa/my/portfolio';
export const PRICE_ALERT = '/fa/my/priceAlert';
export const NOTIFICATIONS = '/fa/my/notifications';
export const FINANCIAL = '/fa/my/profile/financial';
export const ADDRESS_BOOK = '/fa/my/profile/address-book';
// Auth routes - using parameter approach
export const AUTH = '/fa/auth/:loginTab?/:referralCode?'; // Optional parameter with default
export const AUTH_BASE = '/fa/auth'; // Base path for navigation
export const LOGIN = '/fa/auth/login';
export const REGISTER = '/fa/auth/register';
export const REGISTER_WITH_REFERRAL = '/fa/auth/register/:referralCode?'; // New route for referral codes

export const GOOGLE_REGISTER = '/fa/auth/register/google';
export const OTP = '/fa/auth/otp';
export const FORGET = '/fa/auth/forget';
export const CHANGE_PASSWORD = '/fa/auth/forget/password';

export const REFERRAL = '/fa/activity/referral';
export const REDIRECT_TO_IPG = '/fa/app/payment/redirect-to-ipg';
export const MARKETS = '/fa/markets';

export const OTC = '/fa/convert';
export const REWARD_CENTER = '/fa/rewardCenter';
export const DIGITAL_GOLD = '/fa/digital-gold';
export const RWA_ASSETS = '/fa/rwa-assets';

// Helper function to generate OTC URLs
export const getOtcUrl = (
  tab?: 'buy' | 'sell' | 'exchange',
  market?: string
) => {
  const searchParams = new URLSearchParams();

  if (tab) {
    searchParams.set('tab', tab);
  }

  if (market) {
    searchParams.set('market', market);
  }

  const query = searchParams.toString();
  return query ? `/fa/convert?${query}` : '/fa/convert';
};
